// eslint-disable-next-line import/prefer-default-export
export enum ACTIVITIES {
	ACTIVITIES_LOAD_START = 'ACTIVITIES_LOAD_START',
	ACTIVITIES_LOAD_DONE = 'ACTIVITIES_LOAD_DONE',
	ACTIVITIES_LOAD_FAIL = 'ACTIVITIES_LOAD_FAIL'
}
